import * as React from 'react';

import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 19px;
  height: 14.009px;
  margin-right: 0.5rem;
`;

const TreeEyeIcon = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg">
      <path
        data-name="eye icon"
        d="M19 6.825s-3.366 5.656-9.488 5.656a8.951 8.951 0 0 1-3.049-.56l1.277-1.2a7.071 7.071 0 0 0 1.771.243c3.793 0 6.415-2.678 7.524-4.073a12.012 12.012 0 0 0-2.84-2.242l1.179-1.109A12.9 12.9 0 0 1 19 6.825zM8.475 10.03l4.03-3.791a3.1 3.1 0 0 1-4.031 3.791zm2.283-5.643A3.094 3.094 0 0 0 6.59 8.34l-1.367 1.3a14.2 14.2 0 0 1-3.214-2.779 10.586 10.586 0 0 1 7.5-3.488 9.117 9.117 0 0 1 2.066.24zM15.52 0l-2.649 2.382a10.868 10.868 0 0 0-3.36-.531c-5.992 0-9.512 4.974-9.512 4.974a16.026 16.026 0 0 0 4.074 3.9l-2.3 2.209 1.119 1.074L16.643 1.073z"
        fill="#4694ce"
      />
    </Svg>
  );
};

export default TreeEyeIcon;
